<script>
  /** @type {{ label: string, value?: boolean | null }} */
  const { label, value = null } = $props();

  const valueClass = $derived(
    value === true ? "checklist-true" : value === false ? "checklist-false" : "checklist-null"
  );

  const valueText = $derived(
    value === true ? "Y" : value === false ? "N" : "--"
  );
</script>

<div class="checklist-item">
  <span class="checklist-swatch {valueClass}">{valueText}</span>
  <span class="checklist-label">{label}</span>
</div>
<style>
.checklist-item:not(:first-child) {
  border-top: solid 2px var(--color-white);
  padding-top: var(--spacing-4);
}
.checklist-item {
  display: flex;
  font-size: var(--font-size-small);
  gap: var(--spacing-2);
}
.checklist-swatch {
  height: 18px;
  width: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-white);
  flex-shrink: 0;
}
.checklist-swatch.checklist-true {
  background-color: var(--color-green);
}
.checklist-swatch.checklist-false {
  background-color: #c53030;
}

</style>
